import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { Authenticationservice } from '../../services/authentication.service';
import axios from 'axios';

@Component({
  selector: 'app-cane-yard',
  templateUrl: './cane-yard.component.html',
  styleUrls: ['./cane-yard.component.css']
})
export class CaneYardComponent implements OnInit {
  constructor(private http: HttpClient, private storage: AngularFireStorage, private auth: Authenticationservice, private spinner: NgxSpinnerService) {
    let userdata;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.supcode = userdata.supcode;
    this.userlv = userdata.userlevel
    console.log('userdata: ', userdata);
    if (userdata.userlevel == '6' || userdata.userlevel == '7' || userdata.userlevel == '9' || userdata.userlevel == '10') {
      this.editer = true
    } else this.editer = false;

  }
  editer: boolean;
  zone = '';
  supcode = '';
  userlv = '';
  sYear = [];
  yearid = "";
  yearTh = "";
  yearidLb = "";
  yearLblast = "";
  yearLst = "";
  yearLft = "";

  fmcode = '';
  url_load = '';
  isUploading = false;

  listYear = ['2526', '6869', '2568/2569', '68'];

  ngOnInit() {
    console.log('userlv:', this.userlv)
    this.selectYear()

  }

  selectYear() {
    let ar = this.listYear;
    this.yearid = ar[0];
    this.yearidLb = ar[1];
    this.yearTh = ar[2];
    this.yearLft = ar[3];
  }

  plot_d = [];
  plot_data() {
    this.DataList = [];
    this.spinner.show();
    let year = this.yearidLb
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=[itid],[year],[intlandno],[fmcode],[fmname],[supzone],[groupCode],[landvalue],[canetype],[PlantDate],[caneage],[Ton],[Assess],[Qtype],[Cutseed],[canein],[growed1],0[num]"
      + "&f=[CPS6263].[dbo].[v_cp" + year + "_basic]&w= [fmcode]='" + this.fmcode + "'";
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      if (data.length >= 1) {
        data.sort(function (a: any, b: any) { return a.intlandno - b.intlandno });
        this.plot_d = data;
        console.log('DataList:', data);
      }
    }).catch(err => { throw (err) })
  }
  saw() {

  }

  DataList = [];
  LoadDataLists() {
    this.DataList = [];
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*"
      + `&f=[dbQBRD].[dbo].[v_CaneYard]&w=[year]='${this.yearidLb}'and[fmcode]='${this.fmcode}'order by[dateAdd]desc`;
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      if (data.length >= 1) {
        //data.sort(function (a: any, b: any) { return a.intlandno - b.intlandno });
        //data.sort((a, b) => b.dateAdd.getTime() - a.dateAdd.getTime());
        this.DataList = data;
        console.log('DataList:', data);
      }
    }).catch(err => { throw (err) })
  }
  famerdl = [];
  fm_select = [];


  dataQcard = [];
  async addToQcard(data) {
    //console.log('test_url_data_addToQcard:', data);
    this.dataQcard = [];
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/exec_f_v?f=[dbQBRD].dbo.[addToQcard1234]&v=4,'${data.intlandno}',${data.num}`;
    //console.log('test_url_insert:', url);
    if (data.num > 100) alert("ไม่สามารถ ขอได้เกินครั้งละ 100 ");
    else {
      if (confirm(`ต้องการขอบาร์โค้ดลาน สำหรับแปลง ${data.intlandno} ,จำนวน ${data.num} เที่ยว`)) {
        this.spinner.show();
        axios.get(url).then(res => {
          this.spinner.hide();
          let data1 = res.data.recordset;
          console.log('dataQcard:', data1);
          if (data1.length > 0) {
            this.dataQcard = data1;
            this.insert_to(data, data1[0])
          }
        }).catch(err => { throw (err) })
      }
    }
  }

  async insert_to_brr() {
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/exec_f_v?f=[dbQBRD].dbo.[add_data_qcardYard_To_brr]`;
    axios.get(url).then(res => {
    }).catch(err => { throw (err) })
  }

  doc = '';
  async insert_to(data0, data1) {
    console.log('data0, data1:', data0, data1);
    let year = this.yearidLb
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_t_c_v?t=[dbQBRD].[dbo].[CaneYard]&c=[year],[itid],[landno],[fmcode],[amount],[userAdd],truck_q1,truck_q2&v='${year}','${data0.itid}','${data0.intlandno}','${data0.fmcode}',${data0.num},'${this.supcode}','${data1.min_truck_q}','${data1.max_truck_q}' `;
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_fileUpload?[year]=" + year + "&[fileType]=01&[doc]=" + this.doc + "&[fmcode]=" + this.fm_select[0] + "&[userAdd]=" + this.supcode + "&[link]=" + this.url_load;
    console.log('test_url_insert:', url);
    axios.get(url).then(async res => {
      if (res.data.rowsAffected[0] >= 1) {
        alert("บันทึกข้อมูลสำเร็จ ");
        this.LoadDataLists();
        await this.insert_to_brr();
      }
    }).catch(err => { throw (err) })
  }

  THtoLocal(thisdate: string) {
    if (!thisdate) { return ''; }
    const date1 = new Date(thisdate);
    let options: any = {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: 'UTC',
    };
    return date1.toLocaleString('th-TH', options);
  }

}
